import { IconButton, twClassMerge  } from '@healthhub/react-ui';
import { useState } from 'react';

import { HealthHubIcon } from '@shared/assets';
import { PortalOutlinedArrowDownIcon, PortalOutlinedCircleCloseIcon } from '@shared/assets-icon';
import { MaxWidthContainer } from '@shared/components';
import { sitecoreHomeBaseUrl } from '@shared/configs/configs/config';
import useToggle from '@shared/hooks/useToggle/useToggle';


import { HeaderAction, MobileHeaderDrawer } from './components';
import { useHeaderMenu } from './hooks';

const PageHeader = () => {
  const { headerMenu } = useHeaderMenu();
  const [isMenuOpen, toggleMenu, setIsMenuOpen] = useToggle(false);

  const [activeMenu, setActiveMenu] = useState<string | undefined>();

  const onClickMenu = (label?: string) => {
    if (label === activeMenu || !label) {
      setActiveMenu(undefined);
      document.body.classList.remove('overflow-hidden');
      return;
    }

    setActiveMenu(label);
    document.body.classList.add('overflow-hidden');
  };

  return (
    <header className="relative w-full shadow-portal-card">
      <div className="flex justify-center bg-white lg:px-18 lg:py-6">
        <MaxWidthContainer className="relative flex items-center justify-between">
          <a href={sitecoreHomeBaseUrl()}>
            <img alt="HealthHub" className="ml-4 h-10 w-auto lg:ml-0 lg:h-19 lg:w-44 shrink-0" src={HealthHubIcon} />
          </a>
          <HeaderAction isMenuOpen={isMenuOpen} setIsMenuOpen={setIsMenuOpen} toggleMenu={toggleMenu} />
        </MaxWidthContainer>
      </div>
      <div className="relative hidden justify-center border-t-2 border-t-primary-green-3 bg-primary-green-4 lg:flex">
        <MaxWidthContainer className="flex items-center">
          {headerMenu.map(({ component, label }) => {
            const isActive = activeMenu === label;

            return (
              <div className="group grow" key={label}>
                <button
                  className={twClassMerge('relative w-full hover:bg-primary-green-5', isActive && 'bg-primary-green-5')}
                  onClick={() => onClickMenu(label)}
                >
                  <div className="flex gap-2 lg:px-5 lg:py-3.5 items-center justify-center">
                    <h5 className="m-0 text-center text-lg font-medium text-white" lang="en">
                      {label}
                    </h5>
                    <PortalOutlinedArrowDownIcon
                      className={twClassMerge(
                        'size-4px shrink-0 [&_path]:stroke-white duration-300 transition-all',
                        isActive && 'rotate-180'
                      )}
                    />
                  </div>
                  <div
                    className={twClassMerge(
                      'absolute -bottom-2 left-[46%] z-header hidden h-0 w-0 border-x-8 border-t-8 border-transparent border-t-primary-green-5',
                      isActive && 'block'
                    )}
                  />
                </button>
                {!!isActive && (
                  <div
                    aria-hidden="true"
                    // TODO: Update overlay color after confirm design
                    className="absolute top-full inset-0 h-screen w-screen bg-black/50 z-overlay-20"
                    onClick={() => onClickMenu()}
                  />
                )}
                <div
                  className={twClassMerge(
                    'absolute top-full left-0 z-overlay-20 hidden right-0 justify-center bg-functional-beige shadow-[0px_8px_30px_0px_rgba(0,0,0,0.3)] lg:px-18',
                    isActive && 'flex'
                  )}
                >
                  <MaxWidthContainer className="flex min-h-80 py-6">
                    <div className="flex flex-col w-full gap-3">
                      <IconButton
                        aria-label="Close"
                        className="self-end"
                        icon={<PortalOutlinedCircleCloseIcon className="size-6" />}
                        onClick={() => onClickMenu()}
                      />
                      {component}
                    </div>
                  </MaxWidthContainer>
                </div>
              </div>
            );
          })}
        </MaxWidthContainer>
      </div>
      <MobileHeaderDrawer isOpen={isMenuOpen} />
    </header>
  );
};

export default PageHeader;
